import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Hero } from "@/components/site/Hero";
import { News } from "@/components/site/News";
import { Stories } from "@/components/site/Stories";
import { WhyUs } from "@/components/site/WhyUs";
import { Services } from "@/components/site/Services";
import { TourInfo } from "@/components/site/TourInfo";
import { Gallery } from "@/components/site/Gallery";
import { Booking } from "@/components/site/Booking";
import { Levels } from "@/components/site/Levels";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { usePageMeta } from "@/components/site/PageHero";

const SectionHead = ({ eyebrow, title, to, label, testid }) => (
  <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
    <div>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">{title}</h2>
    </div>
    <Link to={to} data-testid={testid} className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-semibold uppercase tracking-wider text-white transition-colors hover:border-white">
      {label} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
    </Link>
  </Reveal>
);

export default function Home() {
  usePageMeta();
  return (
    <>
      <Hero />
      <Stories />
      <News />
      <WhyUs />
      <Services />
      <TourInfo />
      <section data-testid="home-levels-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
        <SectionHead eyebrow="Eğitim seviyeleri" title="Seviyene göre eğitim." to="/egitimlerimiz" label="Tüm eğitimler" testid="home-levels-link" />
        <Levels />
      </section>
      <Gallery />
      <Booking />
    </>
  );
}
